import {
  Button,
  Checkbox,
  FormControl,
  Grid,
  Input,
  InputLabel,
    InputAdornment,
  // LinearProgress,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
  // InputAdornment,
} from "@material-ui/core";
import {  Email,  Info } from "@material-ui/icons";
import { Box, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "src/components/Component";
import CloseIcon from "@material-ui/icons/Close";
// import { Email } from "@material-ui/icons";
import Modal from "src/components/Modal";
// import PartialCleanCheck from "src/components/PartialCleanCheck";
import withAxios from "src/components/withAxios";
import { withSchoolContext } from "../../../../DirectorPage";
import "src/pages/home/signUp-pages/style.css";
import EmailValidator from "email-validator";
import { styles } from "./styles";
import { IBaseProps, IEditCoachModalState2, IProps } from "./types";
import { IUser } from "src/services";
import { IHeadCoach } from "./types";

export default withSchoolContext<IBaseProps>(
  withStyles(styles, { withTheme: true })(
    withAxios(
      class extends Component<IProps, IEditCoachModalState2> {
        public readonly state = this.buildState({
          directorEmail: "",
          headCoachEmail: "",
          FirstName: "",
          LastName: "",
          coachFirstName: "",
          coachLastName: "",
          email: "",
          error: false,
          submitting: false,
          ...(this.state as any),
          editModalDirectorIndex: "",
          modalStatus: "",
          adEditModal: false,
          coachEditModal: false,
          directors: [],
          headCoachDirectors: [],
          jvCoachList: [],
          loading: false,
          coachSports: [],
          editSports: [],
          particularCoachId: "",
          isMeadSeason: false,
          assignedSports: [],
          assignedSports2: [],
        });

        // ✅ private/public handlers first
        // private readonly handleNewHeadCoachEmailChange =
        //   this.stateInputEventHandler((v) => ({ headCoachEmail: v?.trim() }));

   private readonly handleNewHeadCoachEmailChange =
  this.stateInputEventHandler((v) => {
    const trimmedEmail = v?.trim() || "";

    // Update state
    const newState = { headCoachEmail: trimmedEmail };

    // Check if valid email → run API
    if (EmailValidator.validate(trimmedEmail)) {
      this.checkEmailExists(trimmedEmail); // onChange check
    }

    return newState;
  });

                    
        public handlecoachFirstName = (
          e: React.ChangeEvent<HTMLInputElement>
        ) => {
          const { value } = e.target;
          this.setState((prevState) => ({
            ...prevState,
            coachFirstName: value,
          }));
        };

        public handlecoachLastName = (
          e: React.ChangeEvent<HTMLInputElement>
        ) => {
          const { value } = e.target;
          this.setState((prevState) => ({
            ...prevState,
            coachLastName: value,
          }));
        };

        // ✅ lifecycle methods next
        public componentDidMount = async () => {
          const res: any = await this.buildGet<IUser>(this, "user")();
          const hhheadcoch = await this.buildPost<
            { userId: any; schoolId: any },
            any
          >(this, "/coaches/getHeadCoach")({
            userId: res?.id,
            schoolId: this.props.school.id,
          });
          console.log("meadseson res:::::", hhheadcoch, hhheadcoch, this.props);
          if (hhheadcoch?.data?.type === "head" && hhheadcoch?.data !== null) {
            this.setState({
              isMeadSeason: true,
              particularCoachSportId: hhheadcoch?.data?.sportId,
            });
          }
        };

        public componentDidUpdate = async (prevProps: IProps) => {
          const { open: prevOpen, coach: prevCoach } = prevProps;
          const { open, coach } = this.props;

          if (!prevOpen && open) {
        
            this.setState((prevState) => ({
              ...(prevState as any),
              coachFirstName: "",
              coachLastName: "",
              coachSports: [],
              headCoachEmail: ""
            }));
            this.setState({ name: "", disableEditing: false });
          }

          if (
            (!prevOpen && open && !!coach) ||
            (!!coach && !!prevCoach && coach.id !== prevCoach.id) ||
            (!!coach && !prevCoach)
          ) {
            this.setState((_) => {
              const newState = {
                active: coach.active,
                coachSports: coach.sports.map((sport) => sport.name),
                name: coach.name,
                coachEmail: coach?.user?.email ?? "",
              };
              return newState;
            });
          }
        };

        // ✅ render last
        public render() {
          const { particularCoachSportId, isMeadSeason } = this.state;
          const coachFirstName = (this.state as any).coachFirstName;
          const coachLastName = (this.state as any).coachLastName;
          const { classes, open, sports } = this.props;
          const { coachSports } = this.state;

          return (
            <Modal
              open={open}
              closeModal={this.props.closeModal}
              className={classes.coachModal}
            >
              <Grid
                container={true}
                style={{ height: "100%" }}
                direction="column"
                justifyContent="space-between"
              >
                <div className="head-coch-inners">
                  <Box>
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      <div className="input-edit-corner">
                      <h3 className="MuiTypography-root MuiTypography-h3" style={{fontSize: "2rem"}}>
                        VARSITY HEAD TEACHER
                      </h3>
                      <Button 
                      onClick={()=>{this.props.closeModal();}}
                  
                      ><CloseIcon /></Button>
                      </div>
                      <TextField
                       className="mt-4"
                        label={
                          <span
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            Varsity Head Teacher Email 
                            <Tooltip
                              enterTouchDelay={0}
                              leaveTouchDelay={4000}
                              placement="right"
                              title={
                                <Typography style={{ fontSize: "14px" }}>
                                  Add your varsity head teachers here to manage
                                  their mid-season check-ins. They will then be
                                  able to add any junior teachers as needed.
                                </Typography>
                              }
                            >
                              <Info
                                style={{
                                  marginLeft: 5,
                                  fontSize: 25,
                                  cursor: "pointer",
                                }}
                              />
                            </Tooltip>
                          </span>
                        }
                        value={this.state.headCoachEmail}
                        onChange={this.handleNewHeadCoachEmailChange}
                        onBlur={() => {
    const email = this.state.headCoachEmail?.trim();
    if (EmailValidator.validate(email)) {
      this.checkEmailExists(email); // API call only if valid
    }
  }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Email />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>

                    <TextField
                     className="mt-2"
                      label="First Name"
                      value={coachFirstName}
                      onChange={this.handlecoachFirstName}
                      required={this.state.headCoachEmail ? true : false}
                    />
                    <TextField
                      className="mt-2"
                      label="Last Name"
                      onChange={this.handlecoachLastName}
                      value={coachLastName}
                      required={this.state.headCoachEmail ? true : false}
                    />
                    <FormControl className="mt-2">
                      <InputLabel
                        className="select-input-coach "
                        htmlFor="select-multiple-checkbox"
                      >
                        {"Subject"}
                      </InputLabel>
                     <Select
  className="text-coach-bottom"
  label="Select subject"
  multiple={true}
  value={coachSports}
  input={<Input id="select-multiple-checkbox" />}
  renderValue={(selected) => {
    const selectedLabels = (selected as number[])
      .map((id) => sports.find((option) => option.id === id)?.name)
      .filter(Boolean);
    return selectedLabels.join(", ");
  }}
>
  {(
    isMeadSeason
      ? sports.filter((s) => particularCoachSportId.includes(s.id))
      : this.props?.schoolData?.isAdSurvey
      ? sports.filter((s) => [72, 74, 73, 68].includes(s.id))
      : sports.filter((s) => ![72, 74, 73, 68].includes(s.id))
  ).map((sport) => {
    const { assignedSports } = this.props;
    const isAssigned = assignedSports.includes(sport.id);

    return (
      <MenuItem
        key={sport.id}
        value={sport.id}
        onClick={(e) => {
          if (isAssigned) {
            e.preventDefault();
            alert(
              `${sport.name} is already assigned to another teacher. Please remove it from the current teacher before assigning this subject to a different one.`
            );
            return;
          }

          const updatedSports = coachSports.includes(sport.id)
            ? coachSports.filter((id: number) => id !== sport.id)
            : [...coachSports, sport.id];

          this.setState({ coachSports: updatedSports });
        }}
      >
        <Checkbox checked={coachSports.includes(sport.id)} />
        <ListItemText primary={sport.name} />
      </MenuItem>
    );
  })}
</Select>
                    </FormControl>
                    <div className="btn-new-coach">
                    <Button 
                     onClick={this.addHeadCoach}
                    variant="contained" color="primary">
                      ADD
                    </Button></div>
                  </Box>
                </div>
              </Grid>
            </Modal>
          );
        }
private readonly checkEmailExists = async (email: string) => {
  if (!EmailValidator.validate(email)){ return;} // Only check if valid

  try {
    const admins: any = await this.buildGet<any>(this, "/user/get-all-admin")();
    const adminList = admins?.data || [];
    const isAlreadyAdmin = adminList.some(
      (admin: any) => admin.email.toLowerCase() === email.trim().toLowerCase()
    );

    if (isAlreadyAdmin) {
      window.alert(
        "This email is already registered as the admin for this school. Please use a different email address."
      );
      this.setState({ headCoachEmail: "" }); 
      
    }
  } catch (error) {
    console.error("Error checking admin email:", error);
  }
};

                   private readonly canSubmit2 = (): { isValid: boolean; errors: string[] } => {
                      const { headCoachEmail, coachSports } = this.state;
                      const coachFirstName = (this.state as any).coachFirstName;
                      const coachLastName = (this.state as any).coachLastName;
                       // Validate First Name (should not be empty)
                      const isFirstNameValid = Boolean(coachFirstName);
                       // Validate Last Name (should not be empty)
                       const isLastNameValid = Boolean(coachLastName);
                        // Validate Sport selection (at least one sport must be selected)
                      const isSportSelected = coachSports.length > 0;
                      // Initialize an array to hold error messages
                      const errors: string[] = [];
                    
                      // Validate email using EmailValidator
                      const isEmailValid = EmailValidator.validate(headCoachEmail);
                      const isEmailProvided = Boolean(headCoachEmail && headCoachEmail.trim());
                      if (!isEmailProvided) {
                        errors.push("Email address cannot be blank.");
                      }else if (!isEmailValid) {
                        errors.push("Invalid email address.");
                      }else if (!isFirstNameValid) {
                        errors.push("First Name cannot be empty.");
                      }else if (!isLastNameValid) {
                        errors.push("Last Name cannot be empty.");
                      }else if (!isSportSelected) {
                        errors.push("At least one subject must be selected.");
                      }
                    
                      // Return validation result and errors
                      return { isValid: isEmailValid && isFirstNameValid && isLastNameValid && isSportSelected, errors };
                    };
            private readonly addHeadCoach = () => {
                      // Extract fields from state
                      const coachFirstName = (this.state as any).coachFirstName;
                      const coachLastName = (this.state as any).coachLastName;
                      const { headCoachEmail, coachSports } = this.state;
                    
                      // Run validations
                      const { isValid, errors } = this.canSubmit2();
                    
                      if (!isValid) {
                        // Show validation errors in an alert
                        window.alert(errors.join("\n"));
                        return; // Exit the function if validation fails
                      }
                    
                      // If validation passes, proceed with the API call
                      return void this.runCancellableStatefulAsync(
                        this,
                        {},
                        { directorEmail: "" },
                        async () => {
                          try {
                            const admins: any = await this.buildGet<any>(this, "/user/get-all-admin")();
        const adminList = admins?.data || [];
        const isAlreadyAdmin = adminList.some(
          (admin: any) =>
            admin.email.toLowerCase() === headCoachEmail.trim().toLowerCase()
        );

        if (isAlreadyAdmin) {
          window.alert(
            "This email is already registered as the admin for this school. Please use a different email address."
          );
          return;
        }
                            const res: any = await this.buildGet<IUser>(this, "user")();
                            const response: any = await this.buildPost<IHeadCoach, void>(
                              this,
                              "/coaches/createHeadCoach"
                            )({
                              email: headCoachEmail.trim().toLowerCase(),
                              schoolId: this.props.school.id,
                              firstName: coachFirstName,
                              lastName: coachLastName,
                              sportId: coachSports,
                              user_id: res?.id,
                              invited_role: "headcoach"
                            });
                    
                            console.log("API Response:", response);
                            window.alert(`Varsity Head Teacher added successfully.`);
                             if (this.props.refreshCoaches) {
          this.props.refreshCoaches();
        }
                    this.props.closeModal();
                            if (response?.status === false) {
                              // window.alert(`${ADD_DIRECTOR_FAILURE}: This is the Main AD`);
                              this.resetFormFields();
                              return;
                            }
                            this.resetFormFields();
                            // this.loadAdDirectors();
                          } catch (error) {
                            console.error("Error while adding head coach:", error);
                            this.resetFormFields();
                            // window.alert(`${ADD_DIRECTOR_FAILURE}: Error occurred while adding the coach`);
                          }
                        },
                        () => {
                          this.resetFormFields();
                        //  window.alert(`${ADD_DIRECTOR_FAILURE}: Operation was canceled or failed unexpectedly.`);
                        }
                      );
                    };

                     private resetFormFields = () => {
            this.setState((prevState) => ({
              ...(prevState as any),
              coachFirstName: "",
              coachLastName: "",
              coachSports: [],
              headCoachEmail: ""
            }));
          };
      }
    )
  )
);




// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/edit-coach-modal/addVarsitycochaMoadal.tsx